import { combineReducers } from "redux";

import auth from "./auth";
import sidebar from "./sidebar";
import modal from "./modal";
import modalSelectConvenio from "./modalSelectConvenio";
import modaisMinimizados from "./modaisMinimizados";
import modalCadastroPropostas from "./modalCadastroPropostas";
import modalEdicaoPropostas from "./modalEdicaoPropostas";
import modalCadastroClientes from "./modalCadastroClientes";
import modalEdicaoClientes from "./modalEdicaoClientes";
import modalSettings from "./modalSettings";
import modalLocalWorking from "./modalLocalWorking";
import modalCustomer from "./modalCustomer";
import modalPhoto from "./modalPhoto";
import modalDocs from "./modalDocs";
import modalComissions from "./modalComissions";
import modalStatus from "./modalStatus";
import modalViewDocs from "./modalViewDocs";
import modalViewDocsClientes from "./modalViewDocsClientes";
import modalPrint from "./modalPrint";
import modalSales from "./modalSales";
import modalErrosImportacao from "./modalErrosImportacao";
import modalRate from "./modalRate";
import modalCompromissos from "./modalCompromissos";
import modalCompromissosEdit from "./modalCompromissosEdit";
import modalVideos from "./modalVideos";
import error from "./error";
import success from "./success";
import successImportacoes from "./successImportacoes";
import alert from "./alert";
import alertDocs from "./alertDocs";
import alertDocsClientes from "./alertDocsClientes";
import alertComissions from "./alertComissions";
import alertRepasses from "./alertRepasses";
import alertEstornos from "./alertEstornos";
import alertMetas from "./alertMetas";
import loading from "./loading";
import loadingUpload from "./loadingUpload";
import pages from "./pages";
import permissions from "./permissions";
import menu from "./menu";
import content from "./content";

// PAGINAS
import bancos from "./bancos";
import operacoes from "./operacoes";
import origemVendas from "./origemVendas";
import promotoras from "./promotoras";
import produtos from "./produtos";
import cargos from "./cargos";
import tiposUsuarios from "./tiposUsuarios";
import statusProposta from "./statusProposta";
import tabelasConvenios from "./tabelasConvenios";
import lojas from "./lojas";
import usuarios from "./usuarios";
import regioes from "./regioes";
import gruposAcessos from "./gruposAcessos";
import feriados from "./feriados";
import clientes from "./clientes";
import propostas from "./propostas";
import desempenho from "./desempenho";
import rankings from "./rankings";
import propostasAlertas from "./propostasAlertas";
import borderos from "./borderos";
import extratoPago from "./extratoPago";
import gerarRepasses from "./gerarRepasses";
import empresa from "./empresa";
import metas from "./metas";
import relatorioMetas from "./relatorioMetas";
import comunicados from "./comunicados";
import statusAtendimento from "./statusAtendimento";
import formasAtendimento from "./formasAtendimento";
import buscaCliente from "./buscaCliente";
import atendimento from "./atendimento";
import relatorioAtendimento from "./relatorioAtendimento";
import campanhas from "./campanhas";
import consignadoInss from "./consignadoInss";
import dadosCadastrais from "./dadosCadastrais";
import agendamentos from "./agendamentos";
import organograma from "./organograma";
import dashboard from "./dashboard";
import tiposCompromissos from "./tiposCompromissos";
import calendarioPesquisador from "./calendarioPesquisador";
import categoriasPagamentos from "./categoriasPagamentos";
import categoriasRecebimentos from "./categoriasRecebimentos";
import metodosPagamentos from "./metodosPagamentos";
import lancamentos from "./lancamentos";
import gruposRepasses from "./gruposRepasses";
import extrato from "./extrato";
import contasBancarias from "./contasBancarias";
import coeficientes from "./coeficientes";
import importacoes from "./importacoes";
import categoriasBonusDesconto from "./categoriasBonusDesconto";
import bonusDesconto from "./bonusDesconto";
import calculadora from "./calculadora";
import caller from "./caller";

// PAGE STORES
import bancosStores from "./PageStores/bancosStores";
import operacoesStores from "./PageStores/operacoesStores";
import origemVendasStores from "./PageStores/origemVendasStores";
import promotorasStores from "./PageStores/promotorasStores";
import produtosStores from "./PageStores/produtosStores";
import cargosStores from "./PageStores/cargosStores";
import tiposUsuariosStores from "./PageStores/tiposUsuariosStores";
import statusPropostaStores from "./PageStores/statusPropostaStores";
import tabelasConveniosStores from "./PageStores/tabelasConveniosStores";
import lojasStores from "./PageStores/lojasStores";
import usuariosStores from "./PageStores/usuariosStores";
import regioesStores from "./PageStores/regioesStores";
import gruposAcessosStores from "./PageStores/gruposAcessosStores";
import feriadosStores from "./PageStores/feriadosStores";
import clientesStores from "./PageStores/clientesStores";
import propostasStores from "./PageStores/propostasStores";
import propostasAlertasStores from "./PageStores/propostasAlertasStores";
import borderosStores from "./PageStores/borderosStores";
import extratoPagoStores from "./PageStores/extratoPagoStores";
import gerarRepassesStores from "./PageStores/gerarRepassesStores";
import empresaStores from "./PageStores/empresaStores";
import materiaisApoioStores from "./PageStores/materiaisApoioStores";
import metasStores from "./PageStores/metasStores";
import comunicadosStores from "./PageStores/comunicadosStores";
import statusAtendimentoStores from "./PageStores/statusAtendimentoStores";
import formasAtendimentoStores from "./PageStores/formasAtendimentoStores";
import campanhasStores from "./PageStores/campanhasStores";
import tiposCompromissosStores from "./PageStores/tiposCompromissosStores";
import categoriasPagamentosStores from "./PageStores/categoriasPagamentosStores";
import categoriasRecebimentosStores from "./PageStores/categoriasRecebimentosStores";
import metodosPagamentosStores from "./PageStores/metodosPagamentosStores";
import lancamentosStores from "./PageStores/lancamentosStores";
import gruposRepassesStores from "./PageStores/gruposRepassesStores";
import extratoStores from "./PageStores/extratoStores";
import contasBancariasStores from "./PageStores/contasBancariasStores";
import coeficientesStores from "./PageStores/coeficientesStores";
import importacoesStores from "./PageStores/importacoesStores";
import categoriasBonusDescontoStores from "./PageStores/categoriasBonusDescontoStores";
import bonusDescontoStores from "./PageStores/bonusDescontoStores";

// FILTROS
import filtrosPropostas from "./filtrosPropostas";
import filtrosDesempenhos from "./filtrosDesempenhos";
import filtrosRankings from "./filtrosRankings";
import filtrosExtratoPago from "./filtrosExtratoPago";
import filtrosClientes from "./filtrosClientes";
import filtrosUsuarios from "./filtrosUsuarios";
import filtrosTabelasConvenios from "./filtrosTabelasConvenios";
import filtrosGerarRepasses from "./filtrosGerarRepasses";
import filtrosMetas from "./filtrosMetas";
import filtrosAtendimento from "./filtrosAtendimento";
import filtrosOrganograma from "./filtrosOrganograma";
import filtrosLancamentos from "./filtrosLancamentos";
import filtrosExtrato from "./filtrosExtrato";
import filtrosValoresDiarios from "./filtrosValoresDiarios";
import filtrosCalendarioUsoPesquisador from "./filtrosCalendarioUsoPesquisador";
import filtrosBonusDesconto from "./filtrosBonusDesconto";
import filtrosBorderos from "./filtrosBorderos";

export default combineReducers({
  auth,
  sidebar,
  modal,
  modalSelectConvenio,
  modaisMinimizados,
  modalCadastroPropostas,
  modalEdicaoPropostas,
  modalCadastroClientes,
  modalEdicaoClientes,
  modalSettings,
  modalLocalWorking,
  modalCustomer,
  modalPhoto,
  modalDocs,
  modalComissions,
  modalStatus,
  modalViewDocs,
  modalViewDocsClientes,
  modalPrint,
  modalSales,
  modalErrosImportacao,
  modalRate,
  modalCompromissos,
  modalCompromissosEdit,
  modalVideos,
  error,
  success,
  successImportacoes,
  alert,
  alertDocs,
  alertDocsClientes,
  alertComissions,
  alertRepasses,
  alertEstornos,
  alertMetas,
  loading,
  loadingUpload,
  pages,
  permissions,
  bancos,
  operacoes,
  origemVendas,
  promotoras,
  produtos,
  cargos,
  tiposUsuarios,
  statusProposta,
  tabelasConvenios,
  lojas,
  usuarios,
  regioes,
  gruposAcessos,
  feriados,
  clientes,
  propostas,
  desempenho,
  rankings,
  gerarRepasses,
  empresa,
  propostasAlertas,
  borderos,
  extratoPago,
  metas,
  lancamentos,
  coeficientes,
  extrato,
  contasBancarias,
  relatorioMetas,
  comunicados,
  statusAtendimento,
  formasAtendimento,
  buscaCliente,
  atendimento,
  agendamentos,
  organograma,
  dashboard,
  tiposCompromissos,
  calendarioPesquisador,
  categoriasPagamentos,
  categoriasRecebimentos,
  metodosPagamentos,
  relatorioAtendimento,
  campanhas,
  consignadoInss,
  dadosCadastrais,
  gruposRepasses,
  importacoes,
  propostasAlertasStores,
  bancosStores,
  operacoesStores,
  origemVendasStores,
  promotorasStores,
  produtosStores,
  cargosStores,
  tiposUsuariosStores,
  statusPropostaStores,
  tabelasConveniosStores,
  lojasStores,
  usuariosStores,
  regioesStores,
  gruposAcessosStores,
  feriadosStores,
  clientesStores,
  propostasStores,
  borderosStores,
  extratoPagoStores,
  gerarRepassesStores,
  empresaStores,
  materiaisApoioStores,
  metasStores,
  comunicadosStores,
  statusAtendimentoStores,
  formasAtendimentoStores,
  tiposCompromissosStores,
  campanhasStores,
  categoriasPagamentosStores,
  categoriasRecebimentosStores,
  metodosPagamentosStores,
  lancamentosStores,
  extratoStores,
  contasBancariasStores,
  gruposRepassesStores,
  coeficientesStores,
  importacoesStores,
  filtrosPropostas,
  filtrosDesempenhos,
  filtrosRankings,
  filtrosMetas,
  filtrosExtratoPago,
  filtrosClientes,
  filtrosUsuarios,
  filtrosTabelasConvenios,
  filtrosGerarRepasses,
  filtrosAtendimento,
  filtrosOrganograma,
  filtrosLancamentos,
  filtrosExtrato,
  filtrosValoresDiarios,
  filtrosCalendarioUsoPesquisador,
  filtrosBonusDesconto,
  filtrosBorderos,
  menu,
  content,
  categoriasBonusDesconto,
  categoriasBonusDescontoStores,
  bonusDesconto,
  bonusDescontoStores,
  calculadora,
  caller
});



// WEBPACK FOOTER //
// ./src/store/ducks/index.js